import ChakraThemeProvider from './chakraUI/ChakraThemeProvider'

const AppProvider: React.FC = ({ children }) => {
  return <ChakraThemeProvider>{children}</ChakraThemeProvider>
}

export default AppProvider
